import { Component, EventEmitter, Input } from '@angular/core';

import { Address } from '../../models/models';

import { LocationProvider } from '../../providers/location/location';

@Component({
	selector: 'address-write',
	templateUrl: 'address-write.html',
	inputs: [
		'address',
		'citySelection'
	],
	outputs: [
		'address',
		'citySelection',
		'citySelectionChange',
	]
})
export class AddressWriteComponent {
	private _address: Address = null;

	isCityLoading: boolean = false;

	@Input() public isPriorityWritable: boolean = false;
	@Input() public isTypeWritable: boolean = false;
	@Input() public isLocationWritable: boolean = true;

	@Input() public title: string = '';

	/**
	Stringa usata per cercare la città
	*/
	public cityKeyword: string;
	public citySelectionChange: EventEmitter<any> = new EventEmitter<any>();
	public citySuggestions: string[];

	public get citySelection() {
		return this._address ? this._address.location : null;
	}
	public set citySelection(city) {
		this.address.location = city;
		this.address.location_id = city ? city.id : null;
		this.citySelectionChange.emit(this.address.location);
	}

	public set address(address: Address) {
		if (address) {
			this._address = address
			if (address.location) {
				this.cityKeyword = address.location.name;
			} else {
				this.cityKeyword = null;
			}
		} else {
			this._address = new Address();/* {
				id: null,

				location: null,

				cell: null,
				email: null,
				pec: null,
				fax: null,
				floor: null,
				formatted: null,
				internal: null,
				owner: null,
				name: null,
				owner_id: null,
				owner_type: null,
				postal_code: null,
				phone: null,
				priority: null,
				route: null,
				stair: null,
				street_number: null,
				type: null,

				user: null
			}
			*/
			this.cityKeyword = null;
		}
	}
	public get address() {
		return this._address;
	}

	constructor(private locations: LocationProvider) {
		this.address = null;
	}

	public onCityCancel() {
		this.cityKeyword = null;
		this.citySelection = null;
		this.citySelectionChange.emit(null);
		this.isCityLoading = false;
	}

	public onCityInput(_e: any) {
		this.isCityLoading = true;

		if (!this.cityKeyword || this.cityKeyword.trim() == '') {
			this.citySelection = null;
			this.citySelectionChange.emit(null);
			this.citySuggestions = [];
			return;
		}

		this.locations.search(this.cityKeyword).subscribe(
			(results: any) => {
				console.log("Elenco città ricevuto: ", results);
				this.citySuggestions = results;
				this.isCityLoading = false;
			},
			(error: any) => {
				console.error("Errore leggendo l'elenco città:", error);
			}
		);
	}

	/**
	* select item from list
	* @param item
	*/
	public selectCity(city: any): void {
		this.address.location = city;
		this.cityKeyword = city.name;
		this.citySuggestions = null;
		this.citySelectionChange.emit(city);
	}
}



// WEBPACK FOOTER //
// ./src/components/address-write/address-write.ts